export const authScreen = {
  bg: '#08080a',
  bgElevated: 'rgba(255, 255, 255, 0.04)',
  glass: 'rgba(255, 255, 255, 0.03)',
  glassBorder: 'rgba(255, 255, 255, 0.08)',
  text: '#FAFAFA',
  textMuted: 'rgba(250, 250, 250, 0.55)',
  textDim: 'rgba(250, 250, 250, 0.38)',
  border: 'rgba(255, 255, 255, 0.14)',
  borderFocus: 'rgba(255, 255, 255, 0.35)',
  ring: 'rgba(38, 143, 182, 0.45)',
  brand: '#268FB6',
  brandSoft: 'rgba(38, 143, 182, 0.18)',
  accent: '#6EC8E8',
  accentSoft: 'rgba(110, 200, 232, 0.14)',
  primaryBtnBg: '#FAFAFA',
  primaryBtnFg: '#0a0a0b',
  pillRadius: '12px',
  fieldRadius: '12px',
  cardRadius: '24px',
  maxContentWidth: 440,
  controlHeight: 48,
  font: '"Outfit", system-ui, -apple-system, sans-serif',
} as const;

export const authBackgroundSx = {
  minHeight: '100vh',
  bgcolor: authScreen.bg,
  color: authScreen.text,
  position: 'relative' as const,
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: `
      radial-gradient(ellipse 120% 80% at 0% -20%, ${authScreen.accentSoft}, transparent 50%),
      radial-gradient(ellipse 90% 60% at 100% 0%, ${authScreen.accentSoft}, transparent 45%),
      radial-gradient(ellipse 70% 50% at 50% 110%, rgba(255,255,255,0.04), transparent 40%)
    `,
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    opacity: 0.35,
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E")`,
    pointerEvents: 'none',
  },
};

export const authGlassCardSx = {
  position: 'relative' as const,
  zIndex: 1,
  borderRadius: authScreen.cardRadius,
  border: `1px solid ${authScreen.glassBorder}`,
  bgcolor: authScreen.glass,
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  boxShadow: '0 24px 64px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.06)',
  p: { xs: 2.5, sm: 3.5 },
};

export const authFieldShellSx = {
  borderRadius: authScreen.fieldRadius,
  bgcolor: authScreen.bgElevated,
  border: `1px solid ${authScreen.glassBorder}`,
  px: 1.75,
  py: 1.35,
  minHeight: authScreen.controlHeight,
  display: 'flex',
  alignItems: 'center',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
  '&:focus-within': {
    borderColor: authScreen.borderFocus,
    boxShadow: `0 0 0 3px ${authScreen.ring}`,
    bgcolor: 'rgba(255, 255, 255, 0.06)',
  },
};
